interface IProps {
  size: number;
}

export const GoBackIcon = ({ size }: IProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0.999999L7 4.75L2 8.5L12 16"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
